export const _LOAD_REPORT_TAGS_ = 'Load:ReportTags';
export const _OPEN_TAG_FILTER_MODAL_ = 'Open:ReportTagsFilter';
export const _OPEN_EXPORT_POSTS_MODAL_ = 'Open:ExportReportPosts';

export const TAG_FILTER_ITEM_MODEL = {
  id: null,
  name: null,
};

export const TAG_FILTER_MODEL = {
  id: null,
  name: null,
  conditions: {
    and: [{ ...TAG_FILTER_ITEM_MODEL }],
    or: [],
  },
  date_from: null,
  date_to: null,
};
